// Reference: https://gist.github.com/nmsdvid/8807205
const debounce = (callback, time = 200) => {
  let interval = setTimeout(() => {}, 1e6)
  return (...args) => {
    clearTimeout(interval)
    interval = setTimeout(() => {
      interval = null
      callback(...args)
    }, time)
  }
}

export default debounce
